import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body1, Caption1, makeStyles, mergeClasses, Subtitle1, Title3, tokens, } from '@fluentui/react-components';
const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalL,
        padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalXXL} ${tokens.spacingVerticalXXXL}`,
        boxSizing: 'border-box',
        width: '100%',
        maxWidth: '1680px',
        marginInline: 'auto',
        '@media (max-width: 639px)': {
            padding: `${tokens.spacingVerticalM} ${tokens.spacingHorizontalL} ${tokens.spacingVerticalXXL}`,
        },
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalL,
    },
    // Faixa da marca com círculos decorativos à direita, no lugar de ilustração.
    hero: {
        position: 'relative',
        overflow: 'hidden',
        padding: `${tokens.spacingVerticalXL} ${tokens.spacingHorizontalXXL}`,
        borderRadius: tokens.borderRadius3XLarge,
        border: `1px solid ${tokens.colorBrandStroke2}`,
        backgroundImage: `radial-gradient(circle at calc(100% - 96px) 120%, ${tokens.colorBrandBackground2Hover} 0, ${tokens.colorBrandBackground2Hover} 110px, transparent 111px), radial-gradient(circle at calc(100% - 250px) -40%, ${tokens.colorBrandBackground2Hover} 0, ${tokens.colorBrandBackground2Hover} 130px, transparent 131px), linear-gradient(100deg, ${tokens.colorBrandBackground2} 0%, ${tokens.colorNeutralBackground1} 140%)`,
        backgroundColor: tokens.colorBrandBackground2,
        '@media (max-width: 639px)': { padding: tokens.spacingHorizontalL },
    },
    titleBlock: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalL,
        minWidth: 0,
    },
    iconCircle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '56px',
        height: '56px',
        flexShrink: 0,
        borderRadius: tokens.borderRadiusCircular,
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        fontSize: '28px',
        boxShadow: tokens.shadow8Brand,
    },
    titleText: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXXS,
        minWidth: 0,
    },
    titleRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalS,
    },
    description: { color: tokens.colorNeutralForeground3, maxWidth: '720px' },
    heroDescription: { color: tokens.colorNeutralForeground2, maxWidth: '720px' },
    // Acima dos círculos decorativos da faixa.
    actions: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: tokens.spacingHorizontalS,
        position: 'relative',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalL,
        minWidth: 0,
    },
});
/** Moldura comum das páginas: cabeçalho e as seções de conteúdo. */
export function PageShell({ title, description, icon, badge, actions, children, }) {
    const styles = useStyles();
    const hero = icon !== undefined;
    return (_jsxs("div", { className: styles.root, children: [_jsxs("header", { className: mergeClasses(styles.header, hero && styles.hero), children: [_jsxs("div", { className: styles.titleBlock, children: [hero && (_jsx("span", { className: styles.iconCircle, "aria-hidden": true, children: icon })), _jsxs("div", { className: styles.titleText, children: [_jsxs("div", { className: styles.titleRow, children: [hero ? (_jsx(Title3, { as: "h1", children: title })) : (_jsx(Subtitle1, { as: "h1", children: title })), badge] }), description !== undefined &&
                                        (hero ? (_jsx(Body1, { className: styles.heroDescription, children: description })) : (_jsx(Caption1, { className: styles.description, children: description })))] })] }), actions !== undefined && (_jsx("div", { className: styles.actions, children: actions }))] }), _jsx("div", { className: styles.content, children: children })] }));
}
//# sourceMappingURL=PageShell.js.map